export default "/images/vendor/flag-icon-css/flags/1x1/pe.svg?38abe80e0cb9775bea8ca0a9fd1d216c";